module.exports = __webpack_public_path__ + "static/media/access_url_icn.c09504b0.png";